import React, { useEffect } from 'react';
import { useSelector, useStore } from 'react-redux';
import Grid from '@mui/material/Grid';
import Button from '@material-ui/core/Button';
import API from '../../../create/api';
import { toastr } from 'react-redux-toastr';
import { updateLastCompanyAndClearParcelIds } from '../../../../store/thunk-actions';
import { type AnyAction } from 'redux';
import qs from 'querystring';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useHistory } from 'react-router-dom';
import TableContainer from '@material-ui/core/TableContainer';
import Box from '@mui/system/Box';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import { getLabel, getParcelPrice } from './map';
import * as helper from '../../../../helper/index';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    '& .MuiTableCell-root': {
      border: '1px solid #c7c7c7',
    },
  },
  tableBorder: {
    '& .MuiTableCell-root': {
      border: '1px solid #c7c7c7',
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  createButton: {
    paddingBottom: theme.spacing(2),
  },
  centerAlign: {
    textAlign: 'center',
    'span &': {
      verticalAlign: 'middle',
    },
  },
  tdBorder: { border: '1px solid black ', fontSize: '20px', padding: '0 5px' },
  onlyPrint: { display: 'none' },
  hidePrint: {},
  '@media print': {
    'table tr': {
      pageBreakBefore: 'always',
    },
    hidePrint: {
      display: 'none',
    },
    onlyPrint: { display: 'block' },
    printStyle: {
      border: '1px solid  black',
      fontSize: '20px',
      padding: '0 5px',
    },
    numberSize: { fontSize: '30px' },
  },
}));

export default function CreatePayment() {
  const classes = useStyles();
  const store = useStore();
  const history = useHistory();

  const paymentParcelIds = useSelector((state: any) => state.payment?.parcelIDs);
  const paymentCompany = useSelector((state: any) => state?.payment?.companyID);
  const [company, setCompany] = React.useState({} as any);
  interface Parcel {
    merchant_COD: number;
    COD: number;
    deliveryCharge: number;
    id: string;
    amount: number;
    company: any;
  }
  const [getParcels, setParcels] = React.useState([] as Parcel[]);

  useEffect(() => {
    if (paymentParcelIds.length > 0) {
      const fetchAllParcels = async () => {
        try {
          let allParcels: Parcel[] = [];
          // Strapi has a default limit of 100 items, we need to handle pagination
          // Split the IDs into chunks of 100 or less
          const chunks = [];
          for (let i = 0; i < paymentParcelIds.length; i += 100) {
            chunks.push(paymentParcelIds.slice(i, i + 100));
          }

          // Fetch parcels for each chunk
          for (const chunk of chunks) {
            const queryParams = qs.stringify({ id_in: chunk });
            const parcelInfos = await API.getAll(`${process.env.REACT_APP_API_SERVER}/parcels?${queryParams}`);
            if (Array.isArray(parcelInfos)) {
              allParcels = [...allParcels, ...parcelInfos];
            }
          }

          setParcels(allParcels);
          if (allParcels.length > 0) {
            setCompany(allParcels[0]?.company);
          }
        } catch (error) {
          console.error('Error fetching parcels:', error);
          if (error instanceof Error) {
            helper.axiosErrorHandling(error as any);
          }
        }
      };

      fetchAllParcels();
    } else {
      setParcels([]);
    }
  }, [paymentParcelIds]);

  function createInvoice() {
    const data = {
      parcels: paymentParcelIds,
      company: paymentCompany,
      amount: getParcels.reduce((acc, parcel) => acc + parcel.amount || 0, 0),
    };
    API.create(`${process.env.REACT_APP_API_SERVER}/payments`, data)
      .then((res: any) => {
        toastr.success('Success', 'Invoice Created Successfully');
        store.dispatch(updateLastCompanyAndClearParcelIds(null) as unknown as AnyAction);
        history.push(`/dashboard/paymentshow/${res.id}`);
      })
      .catch((error) => {
        helper.axiosErrorHandling(error);
      });
  }

  return (
    <Grid container>
      <Grid item xs={12} className={classes.createButton} style={{ marginTop: '10px' }}>
        <h1 style={{ textAlign: 'center' }}>Invoice: {company?.name}</h1>
        <hr style={{ borderTop: '5px solid black' }} />
      </Grid>
      <Grid item xs={12} className={classes.createButton}>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead style={{ backgroundColor: 'lightgray' }}>
              <TableRow>
                <TableCell>
                  <b>ID</b>
                </TableCell>
                <TableCell>
                  <b>Booking</b>
                </TableCell>
                <TableCell>
                  <b>APN</b>
                </TableCell>
                <TableCell align="right">
                  <b>Invoice</b>
                </TableCell>
                <TableCell align="left">
                  <b>Customer</b>
                </TableCell>
                <TableCell align="right">
                  <b></b>
                </TableCell>
                <TableCell align="right">
                  <b>COD</b>
                </TableCell>
                <TableCell align="right">
                  <b>DC</b>
                </TableCell>
                <TableCell align="right">
                  <b>Collected</b>
                </TableCell>
                <TableCell align="right">
                  <b>Amount</b>
                </TableCell>
                <TableCell align="right">
                  <b>Del</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getParcels?.map((row: any, index: number) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {index + 1}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.booking_date}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.id}
                  </TableCell>
                  <TableCell align="right">{row?.memoNo}</TableCell>
                  <TableCell align="left">{row?.customerName}</TableCell>
                  <TableCell align="left">{getLabel(row?.status)}</TableCell>
                  <TableCell align="right">{row?.merchant_COD}</TableCell>
                  <TableCell align="right">{row?.deliveryCharge}</TableCell>
                  <TableCell align="right">{getParcelPrice(row)}</TableCell>
                  <TableCell align="right">{row?.amount}</TableCell>{' '}
                  <TableCell
                    style={{ textAlign: 'left', cursor: 'pointer', width: '10px' }}
                    onClick={() => {
                      store.dispatch({
                        type: 'REMOVE_PARCEL_ID',
                        payload: row.id,
                      });
                    }}
                  >
                    <DeleteIcon />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid container justifyContent="flex-end" style={{ backgroundColor: '#fff', border: '1px solid #c7c7c7 ' }}>
          <Grid item xs={4}>
            <Box style={{ width: '100%' }}>
              <Table className={classes.tableBorder}>
                <TableRow>
                  <TableCell>Subtotal Parcel</TableCell>
                  <TableCell align="right">
                    {getParcels.reduce((acc, parcel) => acc + parcel.deliveryCharge + parcel.amount, 0)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Delivery Charge</TableCell>
                  <TableCell align="right">
                    {getParcels.reduce((acc, parcel) => acc + parcel.deliveryCharge, 0)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Total Payment</TableCell>
                  <TableCell align="right">{getParcels.reduce((acc, parcel) => acc + parcel.amount, 0)}</TableCell>
                </TableRow>
              </Table>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className="mt-3">
        <Button variant="contained" color="primary" onClick={createInvoice}>
          Create Invoice
        </Button>
      </Grid>
    </Grid>
  );
}
